"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAcceptedMarketingCookies = exports.getCookiesConsent = exports.getDocumentCookies = exports.getRequestCookies = exports.CookieName = void 0;
var cookie_1 = require("cookie");
var CookieName;
(function (CookieName) {
    CookieName["COOKIE_CONSENT"] = "cookieconsent";
    CookieName["CJE"] = "cje";
})(CookieName = exports.CookieName || (exports.CookieName = {}));
var getRequestCookies = function (request) {
    return (0, cookie_1.parse)(request.header("cookie") || "");
};
exports.getRequestCookies = getRequestCookies;
var getDocumentCookies = function () {
    return (0, cookie_1.parse)(document.cookie || "");
};
exports.getDocumentCookies = getDocumentCookies;
var getCookiesConsent = function (request) {
    var allCookies = (0, exports.getRequestCookies)(request);
    if (allCookies.cookieconsent) {
        var parseCookie = JSON.parse(allCookies.cookieconsent || "");
        return parseCookie;
    }
    return null;
};
exports.getCookiesConsent = getCookiesConsent;
function hasAcceptedMarketingCookies(request) {
    var _a;
    var cookie_consent = (0, exports.getCookiesConsent)(request);
    return (_a = cookie_consent === null || cookie_consent === void 0 ? void 0 : cookie_consent.marketingCookie) !== null && _a !== void 0 ? _a : false;
}
exports.hasAcceptedMarketingCookies = hasAcceptedMarketingCookies;
//# sourceMappingURL=cookies.js.map